import { QueryKeys } from '@/api/hooks/queryKeys.ts'
import { joinPath } from '@/util/core-functions.util'
import { ApiPaths } from '@/util/paths'
import type { RaceView } from '@/util/views/race.view'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export const useRaceByTeamQuery = (teamId: string) => {
  return useQuery<RaceView, Error>({
    queryKey: [QueryKeys.RACE, teamId],
    queryFn: async () => {
      const response = await axios.get<RaceView>(joinPath(ApiPaths.RACE_BY_TEAM, teamId))
      return response.data
    }
  })
}
